module.exports = __webpack_public_path__ + "img/heart-failure.6cddcec8.png";